export function isApeChain(chainId: number): boolean {
  return chainId === 16350;
}
